"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startsWith_ = startsWith_;

var _iterableStartsWith_ = require("./iterable-starts-with_");

var _stringStartsWith_ = require("./string-starts-with_");

function startsWith_(iterable, config, value) {
  return typeof iterable === 'string' ? (0, _stringStartsWith_.stringStartsWith_)(iterable, config, value) : (0, _iterableStartsWith_.iterableStartsWith_)(iterable, config, value);
}